import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/modules/BotStorePage/index.tsx");
